import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import GoollooperHome from "./goollooper/GoollooperSite";
import {
  GoollooperPrivacy,
  GoollooperTerms,
  GoollooperDeleteAccount,
} from "./goollooper/GoollooperLegal";

/**
 * Goollooper website (goollooper.com) — rebuilt 2026-11-04 on the
 * goollooper-website branch. The IXEE site lives on the ixee-website branch;
 * legacy pages remain unrouted in src/Pages and src/Components.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <Router basename={process.env.PUBLIC_URL || "/"}>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<GoollooperHome />} />
        <Route path="/privacy" element={<GoollooperPrivacy />} />
        <Route path="/privacy-policy" element={<GoollooperPrivacy />} />
        <Route path="/terms" element={<GoollooperTerms />} />
        <Route path="/delete-account" element={<GoollooperDeleteAccount />} />
      </Routes>
    </Router>
  );
}

export default App;
